export default __webpack_public_path__ + "static/media/659.4c0ea16d.gif";